import { baseLinktreeStyles, COMMUNITIES } from "./customization"
import { useAgnosticRouterInfo } from "./useAgnosticRouterInfo"

export const useCommunityCustomization = () => {
  const { asPath, query } = useAgnosticRouterInfo()
  const code = query.code

  // Handle fleamarket pages - use COMMUNITIES entry
  if (asPath.startsWith("/fleamarket")) {
    return COMMUNITIES.fleamarket
  }

  // this is for static generation, when we don't know the code
  if (!code) {
    return null
  }
  if (asPath.includes("/c/") && !Object.keys(COMMUNITIES).includes(code)) {
    return null
  }

  const customizationData = COMMUNITIES[code as keyof typeof COMMUNITIES]

  if (!customizationData) {
    return null
  }

  if (!customizationData.styles?.linktree) {
    const updatedCustomizationData = {
      ...customizationData,
      styles: {
        ...customizationData.styles,
        linktree: baseLinktreeStyles,
      },
    }

    return updatedCustomizationData
  }

  return customizationData
}

export const getUrlFromCode = (code: string) => {
  const communityByRouteCode = COMMUNITIES[code as keyof typeof COMMUNITIES]
  if (communityByRouteCode) return communityByRouteCode.url

  for (const key in COMMUNITIES) {
    // super weird typescript hack, but oh well
    const url = key as keyof typeof COMMUNITIES
    if (COMMUNITIES[url].code === code) return COMMUNITIES[url].url
  }
  return "404"
}
